
import imagelogo from '../../../../../../../src/Assests/ReportImages/certin.jpg';
import logo from '../../../../../../../src/Assests/ReportImages/isecurion1.png';
import { AlignmentType, FrameAnchorType, HorizontalPositionAlign, HorizontalPositionRelativeFrom, ImageRun, Paragraph, TextRun, VerticalPositionAlign, VerticalPositionRelativeFrom, WidthType } from 'docx'

const imageData = await fetch(imagelogo).then(response => response.blob());
const isecurionLogoo = await fetch(logo).then(response => response.blob());

const image = new ImageRun({
    data: await imageData.arrayBuffer(),
    transformation: { width: 816, height: 1056 },
    floating: {
        zIndex: 5,
        horizontalPosition: {
            relative: HorizontalPositionRelativeFrom.PAGE,
            align: HorizontalPositionAlign.CENTER,
        },
        verticalPosition: {
            relative: VerticalPositionRelativeFrom.PAGE,
            align: VerticalPositionAlign.TOP,
        },
    }
});

const image2 = new ImageRun({
    type: 'png',
    data: await isecurionLogoo.arrayBuffer(),
    transformation: { width: 310, height: 82 },
    floating: {
        zIndex: 10,
        horizontalPosition: { offset: 300000 },
        verticalPosition: { offset: 400000 },
    }
});

export const certinDesign = new Paragraph({
    children: [image]
})


export const fontPageBlueImage = new Paragraph({
    children: [image2]
})




export function reportAppName(certInApplicationName) {
    return new Paragraph({
        width: { size: 50, type: WidthType.PERCENTAGE },
        alignment: AlignmentType.CENTER,
        spacing: { line: 276, before: 100, after: 100 },
        frame: {
            type: "absolute",
            position: {
                x: 700,
                y: 6000,
            },
            width: 9000,
            height: 1000,
            anchor: {
                horizontal: FrameAnchorType.MARGIN,
                vertical: FrameAnchorType.MARGIN,
            },
            alignment: {
                x: HorizontalPositionAlign.CENTER,
                y: VerticalPositionAlign.CENTER,
            },
            zIndex: 90,
        },

        children: [
            new TextRun({
                text: `Security Audit Phase 1 Report of ${certInApplicationName} Web Application`,
                font: "Calibri",
                size: 56,
                color: '0070C0',
                allCaps: false,
                italics: false
            }),
        ],
    });
}


export function reportAppDate(dateString) {
    // dateString is in format "DD/MM/YYYY"
    const [day, month, year] = dateString.split('/');

    return new Paragraph({
        width: { size: 70, type: WidthType.PERCENTAGE },
        alignment: AlignmentType.CENTER,
        spacing: { line: 276, before: 100, after: 100 },
        frame: {
            type: "absolute",
            position: { x: 700, y: 9500 },
            width: 9000,
            height: 1000,
            anchor: {
                horizontal: FrameAnchorType.MARGIN,
                vertical: FrameAnchorType.MARGIN,
            },
            alignment: {
                x: HorizontalPositionAlign.CENTER,
                y: VerticalPositionAlign.CENTER,
            },
            zIndex: 90,
        },

        children: [
            new TextRun({
                text: "Report Submission Date: ",
                font: "Calibri",
                size: 56,
                color: '0070C0',
                italics: false
            }),
            new TextRun({
                text: `${day}-${month}-${year}`,
                font: "Calibri",
                size: 56,
                color: '0070C0',
                italics: false
            })
        ],
    });
}


